<div>
    <label
        nz-checkbox
        [nzDisabled]="disabled"
        [ngModel]="checked"
        (ngModelChange)="onChange($event)"
        >{{ option.displayName }}</label
    >
    <!-- <mat-checkbox color="primary" (change)="onChange($event)" [checked]="checked">{{option.displayName}}</mat-checkbox> -->
</div>
